import React from 'react'

function ContactMap() {
    return (
        <div className="">
            <div className="container-fluid">
                <div className="contact-map style2">
                    <iframe title="Royal Garden Beach Resort Location" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d74025.78866383323!2d74.8251617764519!3d12.810851882607217!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3ba35c6e24ed7f33%3A0x4b6c92d479ec462d!2sRoyal%20Garden%20Beach%20Resort!5e0!3m2!1sen!2sin!4v1764739348590!5m2!1sen!2sin" 
                        allowFullScreen=""
                        loading="lazy"
                    />
                    <div className="contact-icon">
                        <img src="assets/img/icon/location-dot3.svg" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ContactMap
